import React, { useReducer } from 'react'
import NavbarContext from './navbarContext';
import NavbarReducer from './navbarReducer';
import { TOGGLE_NAV } from '../types';

const NavbarState = props => {
    const initialState = {

        nav: false,
        
    };

    const [state, dispatch] = useReducer(NavbarReducer, initialState);

    const toggleNav = () => dispatch({ type: TOGGLE_NAV});


    return (
        <NavbarContext.Provider value= {{ nav: state.nav, toggleNav}} >
            
            {props.children}

        </NavbarContext.Provider>

    )
}

export default NavbarState
